export type BrowserDescription = {
  /** e.g. "Chrome", "Safari". Null when unrecognised. */
  browser: string | null
  /** e.g. "macOS", "Windows". Null when unrecognised. */
  os: string | null
}

/**
 * Coarse browser + OS names from a user-agent string, for labels such as
 * "Push is on for this browser (Chrome on macOS)". Order matters: Edge and
 * Opera also claim Chrome, and Chrome also claims Safari.
 */
export function describeBrowser(userAgent: string): BrowserDescription {
  const ua = userAgent || ''

  let browser: string | null = null
  if (/Edg\//.test(ua)) browser = 'Edge'
  else if (/OPR\/|Opera/.test(ua)) browser = 'Opera'
  else if (/Firefox\/|FxiOS\//.test(ua)) browser = 'Firefox'
  else if (/Chrome\/|CriOS\//.test(ua)) browser = 'Chrome'
  else if (/Safari\//.test(ua)) browser = 'Safari'

  let os: string | null = null
  if (/iPhone|iPad|iPod/.test(ua)) os = 'iOS'
  else if (/Android/.test(ua)) os = 'Android'
  else if (/Mac OS X|Macintosh/.test(ua)) os = 'macOS'
  else if (/Windows/.test(ua)) os = 'Windows'
  else if (/CrOS/.test(ua)) os = 'ChromeOS'
  else if (/Linux/.test(ua)) os = 'Linux'

  return { browser, os }
}
